import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { setIsNew, setIsDirty } from "views/logic/slices/viewSlice";
import { updateView } from "views/api/views";
const _extractErrorMessage = (error) => error && error.additional && error.additional.body && error.additional.body.message ? error.additional.body.message : error;
export default (view, entityShare) => async (dispatch) => {
  try {
    await updateView(view, entityShare);
    dispatch(setIsNew(false));
    dispatch(setIsDirty(false));
    UserNotification.success(
      i18n.t("actions_menu.save_success", { ns: "search", title: view.title }),
      i18n.t("save_view_notifications.success_title", { ns: "search" })
    );
  } catch (error) {
    UserNotification.error(
      i18n.t("actions_menu.save_error", { ns: "search", error: _extractErrorMessage(error) }),
      i18n.t("save_view_notifications.error_title", { ns: "search" })
    );
  }
};
